module.exports = __webpack_public_path__ + "static/media/hubpic2.933f2591.jpg";